module.exports = __webpack_public_path__ + "static/media/hall-PF-2026.bf567c6f.svg";